import type { components } from '@/generated/contracts/api-v1';
import { fieldMap, type FieldSpec, type LegacyRow } from './fieldMap';

// environment_types table; LibraryMapping.ToDto(EnvironmentType) in lureo-backend Data/Api/V1/Library/LibraryDtos.cs.
// Read only in v1.
export type EnvironmentTypeDto = components['schemas']['EnvironmentTypeDto'];

const spec = {
  id: 'id',
  // The generic route named the environment_type column after the entity property EnvironmentType1
  name: 'environment_type1',
  createdAt: 'created_at',
  // v1 returns an object ({} when the stored value is not one)
  preferences: { legacy: 'environment_preferences', as: 'jsonText' },
} as const satisfies FieldSpec<EnvironmentTypeDto>;

const map = fieldMap<EnvironmentTypeDto, typeof spec>('Environment type', spec);

export type LegacyEnvironmentType = LegacyRow<typeof spec, EnvironmentTypeDto>;

export const environmentTypeToLegacy = (dto: EnvironmentTypeDto): LegacyEnvironmentType => map.toLegacy(dto);
